import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Section, Field } from "./fields";
import { NONE, toSelectValue, fromSelectValue } from "./selectValue";

export const WeldersSection = ({ form, update, welders1, welders2, employees, fp = () => ({}), onBlownOutByChange }) => (
  <Section title="Welders & sign-off" number="03">
    <Field label={form.vessel_type === "Freezer Assembly" ? "Welder 1 (n/a — Freezer Assembly)" : "Welder 1 *"} {...fp("welder1_id")}>
      <Select
        value={toSelectValue(form.welder1_id)}
        onValueChange={(v) => {
          const id = fromSelectValue(v);
          if (id) update({ welder1_id: id });
        }}
        disabled={form.vessel_type === "Freezer Assembly"}
      >
        <SelectTrigger data-testid="welder1-select" className="border-[#33424f]/30 disabled:opacity-50 disabled:bg-[#f5f1ec]">
          <SelectValue placeholder={form.vessel_type === "Freezer Assembly" ? "Not applicable" : "—"} />
        </SelectTrigger>
        <SelectContent>
          {welders1.map((e) => (
            <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label={form.vessel_type === "Freezer Assembly" ? "Welder 2 (n/a — Freezer Assembly)" : "Welder 2 *"} {...fp("welder2_id")}>
      <Select
        value={toSelectValue(form.welder2_id)}
        onValueChange={(v) => {
          const id = fromSelectValue(v);
          if (id) update({ welder2_id: id });
        }}
        disabled={form.vessel_type === "Freezer Assembly"}
      >
        <SelectTrigger data-testid="welder2-select" className="border-[#33424f]/30 disabled:opacity-50 disabled:bg-[#f5f1ec]">
          <SelectValue placeholder={form.vessel_type === "Freezer Assembly" ? "Not applicable" : "—"} />
        </SelectTrigger>
        <SelectContent>
          {welders2.map((e) => (
            <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label="Blown out by" {...fp("blown_out_employee_id")}>
      <Select
        value={toSelectValue(form.blown_out_employee_id)}
        onValueChange={(v) => {
          const id = fromSelectValue(v);
          // Selecting an employee opens the confirm-and-lock flow (handled by parent).
          // Picking "—" simply clears it (only possible while the record is unlocked).
          if (id) onBlownOutByChange(id);
          else update({ blown_out_employee_id: "" });
        }}
      >
        <SelectTrigger data-testid="blown-out-select" className="border-[#33424f]/30">
          <SelectValue placeholder="—" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>—</SelectItem>
          {employees.filter((e) => e.active).map((e) => (
            <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label="Blown out date" {...fp("blown_out_date")}>
      <Input
        data-testid="blown-out-date"
        type="date"
        value={form.blown_out_date || ""}
        onChange={(e) => update({ blown_out_date: e.target.value })}
        className="border-[#33424f]/30"
      />
    </Field>
  </Section>
);
